import { useCallback, useEffect, useState, type FC } from "react";
import { Link } from "react-router-dom";

import { Nudge } from "@/components/nudges/Nudge";
import { NudgeKeys, useNudges } from "@/hooks/use-nudges";
import { TrackLocations } from "@/hooks/use-segment";
import { useSetPreference } from "@/queries/user-preferences-queries";

export const AutomationsLaunchNudge: FC = () => {
    const { active: nudge, error, isPending } = useNudges();
    const { mutate: setPreference } = useSetPreference();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (isPending || error) {
            return;
        }

        if (nudge?.key === NudgeKeys.AUTOMATIONS_LAUNCH) {
            setOpen(true);
            return;
        }
        setOpen(false);
    }, [isPending, error, nudge?.key]);

    const toggleOpen = useCallback(() => {
        setOpen((previousOpenState) => {
            const isNowOpen = !previousOpenState;
            if (!isNowOpen) {
                setPreference({
                    key: NudgeKeys.AUTOMATIONS_LAUNCH,
                    value: new Date().toISOString(),
                });
            }
            return isNowOpen;
        });
    }, [setPreference]);

    const ariaLabelPrefix = "Announcement - Automations";

    return (
        <Nudge
            open={open}
            toggleOpen={toggleOpen}
            ariaLabelPrefix={ariaLabelPrefix}
            data-testid="nudge-automations-launch-trigger"
            data-track-location={TrackLocations.AutomationsLaunchNudge}
        >
            <Nudge.Content>
                <Nudge.Header>
                    <Nudge.Title>Take the day off</Nudge.Title>
                    <Nudge.Description>Let Ona clear the backlog whilst you go surfing 🏄</Nudge.Description>
                </Nudge.Header>
                <Nudge.Action variant="primary" aria-label={`${ariaLabelPrefix} - Try Now`} asChild>
                    <Link to="/automations">Try Now</Link>
                </Nudge.Action>
            </Nudge.Content>
        </Nudge>
    );
};
